/***********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
2/20/19
HarvestFieldSummary: Harvest metrics for field
***********************************************************/
import React, { Component } from 'react';

class HarvestFieldSummary extends Component {
  render() {
    let { summary } = this.props.query;
    return (
      <ul className="collection z-depth-1 with-header">
        <li className="collection-item avatar">
          <i className="material-icons cyan circle">insert_chart</i>
          <p className="flow-text">Field Metrics</p>
          <p className>By Field</p>
        </li>
        <li className="collection-item harvest-collection field-metrics">
          <table className="highlight bordered responsive-table centered">
            <thead>
              <tr>
                <th>Field</th>
                <th>$Cost per Lb</th>
                <th>$Cost per Acre</th>
                <th>Density</th>
                <th>Lbs per Hour</th>
                { summary.avgPerformanceIndex ? <th>Performance Index</th> : <th></th> }
              </tr>
            </thead>
          <tbody>
            {
              summary.field.map((b) => (
                <tr key={b.key}>
                  <td>{ b.key }</td>
                  <td>${ b.avgCostPerLb }</td>
                  <td>${ b.avgCostPerAcre }</td>
                  <td>{ b.avgDensity } lbs/tree</td>
                  <td>{ b.avgLbsPerHour }</td>
                  { summary.avgPerformanceIndex ? <td>{ b.avgPerformanceIndex }</td> : <td></td> }
                </tr>
              ))
            }
            </tbody>
          </table>
        </li>
      </ul>
    )
  }
}

export default HarvestFieldSummary;




/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/view/report/harvest_field_summary.jsx